const elderlyServiceRouter = {
  path: '/elderlyService', //主体
  name: 'elderlyService',
  redirect: '/orgBuild',
  component: () => import ('@/views/callCenter/main'),
  children: []
}

export default elderlyServiceRouter
